import { render } from "./Gifts_manage.vue?vue&type=template&id=6f0cce04"
import script from "./Gifts_manage.vue?vue&type=script&lang=js"
export * from "./Gifts_manage.vue?vue&type=script&lang=js"
script.render = render

export default script